// Story 15.7 — the super_admin operational console read (Screen 10).
//
// Mirrors `useAdminOrgs` exactly, minus the filters: this read takes no
// parameters, so the query key is the bare constant rather than a tuple carrying
// a filter object. Screen 23 mounts this hook BESIDE `useAdminOrgs` for its four
// platform stat tiles — the totals are estate-wide aggregates rather than a
// property of the page being listed, so they ride the console payload instead of
// forking the directory's paginated envelope.

import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api-client";
import type { AdminConsoleData } from "@/hooks/queries/admin-console-types";

export const ADMIN_CONSOLE_QUERY_KEY = "admin-console";

export function adminConsoleQueryKey() {
  return [ADMIN_CONSOLE_QUERY_KEY] as const;
}

export function adminConsolePath(): string {
  return "/admin/console";
}

export function useAdminConsole() {
  return useQuery({
    queryKey: adminConsoleQueryKey(),
    queryFn: () => apiFetch<AdminConsoleData>(adminConsolePath()),
    // A refusal (403 for a non-super_admin) is terminal for this read; retrying
    // only delays the inline Banner the screen renders instead.
    retry: false,
  });
}
